import type { UpdateUserBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateUser = createApiThunk<void, UpdateUserBody>(
  "users/updateUser",
  async (body: UpdateUserBody, { extra: { sharedRepository } }) => {
    return sharedRepository!.update(body);
  },
);

export const resetUpdateUser = createAction("users/resetUpdateUser");
